@if(attachmentList.length > 0) {
<div class="attachment-list-container">
    @for (data of attachmentList; track data) {
    <div class="attachment-item">
        <span class="attachment-link" (click)="open(data)">{{ shortFileNameWithExt(data.FileName) }}</span>
        <a [href]="data.readUrl" download="{{ data.FileName }}">
                <mat-icon class="attachment-icon">cloud_download</mat-icon>
        </a>
        @if (canDelete) {
        <mat-icon class="attachment-icon" style="cursor: pointer" (click)="remove(data)">cancel_outline</mat-icon>
        }
    </div>
    }
</div>
}